import * as React from 'react';

function ArrowBottomIcon(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 11 7"
            width="11px"
            {...props}
        >
            <path
                d="M1.132 1.166h0a.486.486 0 000 .666L4.85 5.724a.87.87 0 001.272 0l3.746-3.92a.487.487 0 00.005-.661h0a.435.435 0 00-.64-.005L5.804 4.726a.435.435 0 01-.636 0l-3.4-3.56a.435.435 0 00-.636 0"
                stroke={`${props.fill || '#2e2e2e'}`}
                strokeWidth={0.8}
                fillRule="evenodd"
            />
        </svg>
    );
}

export default ArrowBottomIcon;
